import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const Button = styled.a`
    &,
    &:link,
    &:visited{
        padding: 1rem 2rem;
        border-radius: 10000px; 
        color: #fff;
        font-size: 1.3rem;
        background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
        box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.5);
        text-decoration: none;
        cursor: pointer;
        transition: all .3s;


    }

    &:hover{
        transform: translateY(-.5rem);
    }
   
    &:active{
        transform: translateY(0rem);
        
    }

`
